export const listDefaultParam = {
  version: 1,
  // 排序
  sort_stat: 'create_time',
  sort_order: 1,
  // 分页
  page: 1,
  limit: 20,
  extra: {
    scene: 'complaince_ad_list_v2',
    list_version: 'v2',
    page_view_scene: 'view_first',
  },
  // 投后数据统计时间，可以填任意时间
  st: '',
  et: '',
  // 查询哪些字段，可以不填，默认会返回 ad_name ad_id 和 ad_primary_status
  query_list: [],
  // eu合规筛选字段 0-不合规 1-合规
  eu_compliance: [0],
  lifetime: 0,
  relative_time: 0,
  compare_st: '',
  compare_et: '',
  keyword: '',
  search_type: 1,
  selection_filter: '',
  campaign_status: [],
  // 默认填写 no_delete, 过滤删除了的广告
  ad_status: ['no_delete'],
  opt_status: [],
  creative_status: [],
  objective_type: [],
  pricing: [],
  placement_id: [],
  image_mode: [],
  item_source: [],
  smart_creative_material_mode: [],
  ab_test: [],
  having_filter: [],
  country: [],
  province: [],
  city: [],
  particle_locations: [],
  bid_strategy: [],
  age: [],
  gender: [],
  diagnosis_detail: [],
  dedicate_type_profile_page_type: [],
  selection_ids: {
    ad_ids: [],
    campaign_ids: [],
    creative_ids: [],
  },
  dpa_local_audience: [],
  optimize_goal: [],
  promotion_type: [],
  flow_control_mode: [],
  ad_entity_type: [],
  creative_material_mode: [],
  campaign_category: [],
  budget_optimizer_switch: [],
  app_campaign_type: [],
  universal_type: [],
  destination: [],
  ecomm_type: [],
  is_attr_required: 0,
};
